import PropTypes from "prop-types";
import React, { Component } from "react";

import "../../assets/css/toggleButton.css";

export default class ToggleButton extends Component {
  constructor(props) {
    super();
    this.state = {};
  }

  render() {
    const { selected, toggleSelected, ariaLabel } = this.props;
    return (
      <div
        className="toggle-container"
        onClick={toggleSelected}
        role="switch"
        aria-checked={selected}
        aria-label={ariaLabel}
        tabIndex={0}
        onKeyDown={(e) => e.key === ' ' && (e.preventDefault(), toggleSelected(e))}
      >
        <div className={`dialog-button ${selected ? "" : "disabled"}`}
            style={{backgroundColor:selected?"#02B900":""}}
        >
        </div>
      </div>
    );
  }
}

ToggleButton.propTypes = {
  selected: PropTypes.bool.isRequired,
  toggleSelected: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};
